import { CommonPageName, ERRORTYPE } from '../../global';
import { Http, HttpAuth } from '../http.helper';
import { HttpAuthTokenHelper } from '../token.helper';
export class Interceptor {
    constructor(toast, loader, silenceList, silenceLoadingList, router) {
        this.loadingCounters = 0;
        this.timeoutTimeMS = 150;
        this.handleStatus = (status, error) => {
            var _a, _b, _c;
            // 401 response should redirect to login page whatever conditions are
            if (status === 401) {
                if (HttpAuthTokenHelper.isExpired()) {
                    this.router.push(CommonPageName.Login);
                }
                else {
                    this.router.push(CommonPageName.Forbidden);
                }
                return;
            }
            const isSilent = this.checkIfUrlIsSilent((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : '', this.silenceCallList);
            if (!error.response ||
                error.response === undefined
                || isSilent) {
                throw error;
            }
            switch (status) {
                case 400:
                    // Define action for error 400 - Bad Request
                    console.error('Error 400');
                    this.toast.createAndPushToast('Une erreur est survenue.', 'Merci de réessayer plus tard', true, ERRORTYPE.DANGER);
                    break;
                case 401:
                    // Define action for error 401 - Unauthorized
                    console.error('Error 401');
                    this.toast.createAndPushToast("Cette session n'est plus valide", "Vous n'avez pas l'autorisation d'effectuer cette action", true, ERRORTYPE.DANGER);
                    break;
                case 403:
                    // Define action for error 403 - Forbidden
                    console.error('Error 403');
                    this.toast.createAndPushToast('Interdit', 'Cette action est interdite par le serveur.', true, ERRORTYPE.DANGER);
                    break;
                case 500:
                    console.error('Error 500');
                    this.toast.createAndPushToast('Une erreur est survenue.', 'Veuillez patienter quelques instants avant de réessayer.', true, ERRORTYPE.DANGER);
                    break;
                default:
                    this.toast.createAndPushToast('Oops', 'Désolé, une erreur est survenue. Merci de réessayer plus tard.', true, ERRORTYPE.DANGER);
                    break;
            }
        };
        this.handleLoader = (response) => {
            var _a;
            const config = (_a = response.config) !== null && _a !== void 0 ? _a : response;
            const isResponse = response.status ? true : false;
            if (config) {
                // Check si le handler doit ignorer cette url
                if (!this.checkIfUrlIsSilent(config.url, this.silenceCallListForLoading)) {
                    //Si requete alors Sinon reponse alors
                    if (!isResponse) {
                        //Si le loader n'est pas en marche on le lance
                        if (!this.loadingCounters) {
                            this.currentTimeouts = setTimeout(() => {
                                this.loader.setLoaderVisibility(true);
                            }, this.timeoutTimeMS);
                        }
                        this.loadingCounters++;
                    }
                    else {
                        //Si le loader est en marche et qu'il n'y a plus qu'une requete en attente, on coupe le loader
                        if (this.loadingCounters === 1) {
                            clearTimeout(this.currentTimeouts);
                            this.loader.setLoaderVisibility(false);
                        }
                        this.loadingCounters--;
                    }
                }
            }
            else {
                // Impossible a traiter - Reset du compteur pour ne pas bloquer l'utilisateur
                this.loader.setLoaderVisibility(false);
                this.loadingCounters = 0;
                clearTimeout(this.currentTimeouts);
            }
        };
        this.toast = toast;
        this.loader = loader;
        this.silenceCallList = silenceList;
        this.silenceCallListForLoading = silenceLoadingList;
        this.router = router;
    }
    Run() {
        Http.instance.interceptors.request.use((config) => {
            const url = config.url;
            if (url === undefined)
                return config;
            this.handleLoader(config);
            return config;
        }, (error) => {
            this.handleLoader(error);
            return Promise.reject(error);
        });
        Http.instance.interceptors.response.use((response) => {
            const url = response.config.url;
            if (url === undefined)
                return response;
            this.handleLoader(response);
            return response;
        }, (error) => {
            if (error.response) {
                this.handleLoader(error.response);
                const status = error.response.status;
                this.handleStatus(status, error);
                console.error('Erreur: ' + error.response.data.Message);
            }
            else {
                this.handleLoader(null);
                this.handleStatus('404', error);
            }
        });
        HttpAuth.instance.interceptors.request.use((config) => {
            const url = config.url;
            if (url === undefined)
                return config;
            this.handleLoader(config);
            return config;
        }, (error) => {
            this.handleLoader(error);
            return Promise.reject(error);
        });
        HttpAuth.instance.interceptors.response.use((response) => {
            const url = response.config.url;
            if (url === undefined)
                return response;
            this.handleLoader(response);
            return response;
        }, (error) => {
            if (error.response) {
                this.handleLoader(error.response);
                const status = error.response.status;
                this.handleStatus(status, error);
                console.error('Erreur: ' + error.response.data.Message);
            }
            else {
                this.handleLoader(null);
                this.handleStatus('404', error);
            }
        });
    }
    checkIfUrlIsSilent(url, list) {
        for (let i = 0; i < list.length; i++) {
            if (url.includes(list[i])) {
                return true;
            }
        }
        return false;
    }
}
